import { Typography } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { convertToNumberIfPossible } from "lib/number"
import { EmptyValue, isEmptyValue } from "./requested-field-value-empty"

/**
 * Read-only display of a `number` requested field's answer, locale-formatted (thousands separators).
 * `0` is a valid answer, so emptiness is decided by `isEmptyValue` (null/undefined/blank only) before
 * formatting. Counterpart of `number-field-input.js`.
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 * @param {number|string} [props.value]
 */
export function NumberFieldValue({ value }) {
    return (
        <If value={!isEmptyValue(value)}>
            <Typography variant="body2">{formatNumber()}</Typography>
            <Else>
                <EmptyValue />
            </Else>
        </If>
    )

    function formatNumber() {
        const numeric = convertToNumberIfPossible(value)
        return typeof numeric === "number" && !Number.isNaN(numeric) ? numeric.toLocaleString() : value
    }
}
